<template>
  <v-dialog v-bind:value="isloading" persistent max-width="200">
<div style="background-color:#FFF; border-radius:5px;">
      <v-card-text class="text-center pa-10">
        <v-progress-circular :size="70" indeterminate color="amber"/>
      </v-card-text>
</div>
  </v-dialog>
</template>

<script>
  export default{
    name: 'loading',
    props:['isloading']


  }
</script>